import { ref, onMounted } from 'vue';

export function usePwaInstall() {
  const deferredPrompt = ref<any>(null);
  const showInstallButton = ref(false);

  onMounted(() => {
    // Check if app is already installed
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches
      || (window.navigator as any).standalone
      || document.referrer.includes('android-app://');

    if (!isStandalone) {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault();
        deferredPrompt.value = e;
        showInstallButton.value = true;
      });
    }
  });

  const installPwa = async () => {
    if (!deferredPrompt.value) return;
    
    deferredPrompt.value.prompt();
    const { outcome } = await deferredPrompt.value.userChoice;
    
    if (outcome === 'accepted') {
      showInstallButton.value = false;
    }
    
    deferredPrompt.value = null;
  };

  return {
    showInstallButton,
    installPwa
  };
}